import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { SetorCliente } from '../../comum/modelos/setor-cliente';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { SetorService } from '../setor.service';
import { SetorTabsetComponent } from '../setor-tabset/setor-tabset.component';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-ponto-fisico-setor',
  templateUrl: './listar-ponto-fisico-setor.component.html',
  styleUrls: ['./listar-ponto-fisico-setor.component.css']
})
export class ListarPontoFisicoSetorComponent implements OnInit {

  public paginacao: Paginacao;
  public pontosFisicos: PontoFisico[];
  public pontosFisicosSelecionados: PontoFisico[];
  public evento: Evento;
  public filtroPesquisaRazaoSocialBind: string;
  public setoresCliente: SetorCliente[];
  public selecionados: boolean;
  public habilitarSelecaoSetores: boolean;
  public loading = false;
  public statusCode: number;

  constructor(
    private _pontoFisicoService: PontoFisicoService,
    private _comumService: ComumService,
    private _setorService: SetorService,
    private router: Router,
    private _setorTabsetComponent: SetorTabsetComponent,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.pontosFisicos = new Array<PontoFisico>();
    this.pontosFisicosSelecionados = new Array<PontoFisico>();
    this.paginacao = new Paginacao();
    this.evento = this._comumService.evento;
  }

  ngOnInit() {
    this.loading = true;
    this.paginacao.itens = 5;
    this.paginacao.page = 1;

    this._pontoFisicoService.obterPontosFisicoClienteHttp(parseInt(this._cookieService.get('idCliente')))
      .subscribe((pontosFisicos: PontoFisico[]) => {
        this.pontosFisicos = pontosFisicos;
        this.loading = false;
      });

  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaRazaoSocialBind = filtro.value;
  }

  editado(): void {
    this._comumService.evento.atualizar = true;
    setTimeout(() => {
      this._comumService.cleanEvent();
    }, 2000);
  }

  selecionar(pontoFisico: PontoFisico): void {
    pontoFisico.selecionado = !pontoFisico.selecionado;
    if (pontoFisico.selecionado) {
      this.pontosFisicosSelecionados.push(pontoFisico);
    } else {
      const index = this.pontosFisicosSelecionados.indexOf(pontoFisico);
      this.pontosFisicosSelecionados.splice(index, 1);
    }

    if (this.pontosFisicosSelecionados.length > 0) {
      this.habilitarSelecaoSetores = true;
    } else {
      this.habilitarSelecaoSetores = false;
    }
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    if (!this.selecionados) {
      this.habilitarSelecaoSetores = false;
      this.pontosFisicosSelecionados = new Array<PontoFisico>();
    } else {
      this.habilitarSelecaoSetores = true;
    }
    this.pontosFisicos.forEach(pontoFisico => {
      if (this.selecionados) {
        this.pontosFisicosSelecionados.push(pontoFisico);
      }
      pontoFisico.selecionado = this.selecionados;
    });
  }

  receberSetoresClientePontoFisico(setoresPontoFisico: SetorPontoFisico[]) {
    this.loading = true;
    const setoresPontoFisicoInsert = new Array<SetorPontoFisico>();
    const setoresPontoFisicoDelete = new Array<SetorPontoFisico>();
    setoresPontoFisico.forEach(setorPontoFisico => {
      if (!setorPontoFisico.selecionado && setorPontoFisico.idSetorPontoFisico !== undefined && setorPontoFisico.alterado) {
        setoresPontoFisicoDelete.push(setorPontoFisico);
      } else if (setorPontoFisico.selecionado && setorPontoFisico.idSetorPontoFisico === undefined
        && setorPontoFisico.alterado) {
        setoresPontoFisicoInsert.push(setorPontoFisico);
      }
    });
    if (setoresPontoFisicoDelete.length > 0) {
      this._setorService.removerSetoresPontoFisicoHttp(setoresPontoFisicoDelete)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.atualizar = true;
          this.router.navigate(['listar-setores']);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (setoresPontoFisicoInsert.length > 0) {
      this._setorService.cadastrarSetoresPontoFisicoHttp(setoresPontoFisicoInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.atualizar = true;
          this.router.navigate(['listar-setores']);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    this.loading = false;
  }

  voltar(): void {
    this._setorTabsetComponent.voltar();
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/listar-ponto-fisico-setor/listar-ponto-fisico-setor.component.ts